<template>
    <Article>
        <template #header>
            <h2>Contact Information</h2>
        </template>
        <template #content>
            <div style="max-width:600px;margin:auto">
                <p style="text-align:center">
                    Jerrie Daly --
                    <a href="mailto:mmpdtreas@gmail.com">mmpdtreas@gmail.com</a>
                </p>
                <p style="text-align:center">
                    Jaimie Engle, WebMaster --
                    <a href="mailto:burman.news@gmail.com">burman.news@gmail.com</a>
                </p>
                <p style="text-align:center">
                    Robert Menta --
                    <a href="mailto:mmpdpres@gmail.com">mmpdpres@gmail.com</a>
                </p>
                <h3 style="text-align:center"></h3>
                <br />
                <h3 style="text-align:center;margin-bottom:5px">Former Board of Directors</h3>
                <h6 style="text-align:center;margin-top:5px">
                    (disbanded upon final meeting in 2018)
                </h6>
                <p style="text-align:center">
                    <img
                        class="aligncenter size-full wp-image-139"
                        src="https://firebasestorage.googleapis.com/v0/b/merrills-marauders-pd.appspot.com/o/Bob-Menta-Carmen-Menta.png?alt=media"
                        alt="Bob-Menta-Carmen-Menta"
                        width="300"
                        height="175"
                    />
                </p>
                <p style="text-align:center">
                    <strong>President:</strong>
                    Robert Menta
                    <br />
                    <strong>Marauder:</strong>
                    Carmen S. Menta - 2nd Battalion - Blue Combat Team - I&amp;R Platoon
                </p>
                <br />
                <p style="text-align:center">
                    <a
                        href="http://www.merrillsmarauderspd.org/descendant-officers-board/attachment/board-page-me-gpa-2/"
                    >
                        <img
                            class="aligncenter wp-image-970 size-medium"
                            src="https://firebasestorage.googleapis.com/v0/b/merrills-marauders-pd.appspot.com/o/Board-Page-Me-GPA.jpg?alt=media"
                            width="300"
                            height="160"
                        />
                    </a>
                </p>
                <p style="text-align:center">
                    <strong>Vice President/Webmaster:</strong>
                    Jaimie Engle,
                    <a href="mailto:mmpdvicepres@gmail.com">burman.news@gmail.com</a>
                    <br />
                    <strong>Marauder:</strong>
                    Henry &quot;Hank&quot; Kinder - 3rd Battalion - Khaki Combat Team
                </p>
                <br />
                <p style="text-align:center">
                    <img
                        class="aligncenter size-full wp-image-162"
                        src="https://firebasestorage.googleapis.com/v0/b/merrills-marauders-pd.appspot.com/o/Jerrie-Daly-Francis-Ponder.png?alt=media"
                        alt="Jerrie-Daly-Francis-Ponder"
                        width="300"
                        height="175"
                    />
                </p>
                <p style="text-align:center">
                    <strong>Treasurer:</strong>
                    Jerrie Daly,
                    <a href="mailto:mmpdtreas@gmail.com">mmpdtreas@gmail.com</a>
                    <br />
                    <strong>Marauder:</strong>
                    Francis Ponder - New Galahad,&nbsp;Co I, 5307th, Co I, 475th, MARS Task Force
                </p>
                <br />
                <p style="text-align:center">
                    <img
                        class="size-full wp-image-251 aligncenter"
                        src="https://firebasestorage.googleapis.com/v0/b/merrills-marauders-pd.appspot.com/o/Greg-Walker-Wilbur-Littler1.png?alt=media"
                        alt=""
                        width="300"
                        height="175"
                    />
                </p>
                <p style="text-align:center">
                    <strong>Secretary:&nbsp;</strong>
                    Greg Walker
                    <br />
                    <strong>Marauder:</strong>
                    Wilber Littler
                </p>
                <br />
                <p style="text-align:center">
                    <span style="color:#226300">
                        MMPD thanks the following former officers and board members for your
                        dedicated service to the organization and to the men who served the cause.
                    </span>
                </p>
                <p style="text-align:center">
                    Leon Adams
                    <br />
                    Gary Binter
                    <br />
                    Michael Christner
                    <br />
                    Jonnie Melillo Clasen (Liaison Officer)
                    <br />
                    Sherry Weston Cowling
                    <br />
                    Hansel L. Haycox (Historian)
                    <br />
                    Bernie G. Jezercak
                    <br />
                    Kathy Ketcham
                    <br />
                    Sheila Fredrickson (Burman News Editor)
                    <br />
                    Robert E. Passanisi (Historian)
                </p>
                <p style="text-align:center">
                    George Adams
                    <br />
                    Richard Avery
                    <br />
                    Bob Jackson
                    <br />
                    Susie Weston Passanisi
                    <br />
                    Lorrie Carpenter
                    <br />
                    Barry Maltese, Jr.
                    <br />
                    Cecil Cox
                    <br />
                    Joni Newman
                </p>
            </div>
        </template>
    </Article>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import Article from '@/components/Article/Article.vue';

export default defineComponent({
    name: 'ContactInformation',
    components: { Article }
});
</script>
